import classNames from 'classnames'
import React from 'react'
import style from '../styles/best.module.scss'

interface IProps {
  children: any
  checked?: boolean
  onClick: () => void
}

const InstitutionsButton = ({
  children,
  checked = false,
  onClick
}: IProps): React.ReactElement => {
  return (
    <button
      type='button'
      onClick={onClick}
      className={classNames({
        [style.instbtn]: true,
        [style['instbtn--checked']]: checked
      })}
    >
      {children}
    </button>
  )
}

export default InstitutionsButton
